import * as React from 'react';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import FormHelperText from '@mui/material/FormHelperText';

export const MultipleChoiceGrid = ({
  id,
  value,
  updateValue,
  path,
  rows,
  columns,
  description,
  limit,
  errors,
  visible,
}) => {

  const [selectedValue, setSelectedValue] = React.useState(value ?? {});

  const buttonStyle ={
    float: 'right',
    marginLeft: '1em',
  }

  const handleChange = (event, row) => {
    if (limit) {
      if (Object.values(selectedValue).find(value => event.target.value === value)) {
        return;
      }
    }
    let newValue = {
      ...selectedValue,
      [row]: event.target.value,
    }
    setSelectedValue(newValue);
    updateValue(newValue);
  };

  const handleClear = () => {
    setSelectedValue({});
    updateValue({});
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <InputLabel style={{ marginTop: '0.8em' }}>{description}</InputLabel>
      <Grid container spacing={2}>
        <Grid item xs style={{ textAlign: 'center' }}>
          <FormLabel id={`row-column-${path}`}></FormLabel>
        </Grid>
        {columns?.map(column => {
          return (
            <Grid item xs style={{ textAlign: 'center' }}>
              <FormLabel id={`column-${column}`}>{column}</FormLabel>
            </Grid>
          )
        })}
      </Grid>
      {rows?.map(row => {
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs style={{ textAlign: 'center' }}>
                <FormLabel id={`row-${row}`}>{row}</FormLabel>
              </Grid>
              {columns?.map(column => {
                return (
                  <Grid item xs style={{ textAlign: 'center' }}>
                    <Radio
                      checked={selectedValue?.[row] === column}
                      onChange={(event) => handleChange(event, row)}
                      value={column}
                      name={`radio-buttons-${row}`}
                      inputProps={{ 'aria-label': column }}
                    />
                  </Grid>
                )
              })}
            </Grid>
          </>
        )
      })}
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
      <Button
        style={buttonStyle}
        color='primary'
        variant='text'
        onClick={() => handleClear()}
      >
        Clear selection
      </Button>
    </div>
  );
};
